import { slice, isEmpty, get } from "lodash";
import { useCallback, useState } from "react";

import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import { isTagNavigableInTeamform } from "src/util/isTagNavigableInTeamform";
import { getCombinedSortedTags } from "./ExpandableBadgeList.utils";

export const useExpandableBadgeList = ({
  tags,
  defaultLimit,
  initiallyCollapsed,
  onEntityTagClick,
  onClickTagInfo,
  entityType,
}) => {
  const workspace = useWorkspace();
  const enableAllTagsToBeVisible = get(
    workspace,
    "config.featureFlags.enableAllTagsToBeVisible"
  );
  const [isCollapsed, setCollapsed] = useState(
    enableAllTagsToBeVisible === true ? false : initiallyCollapsed
  );

  const onInfo = useCallback(
    (tag, config) => {
      onClickTagInfo(tag, config);
    },
    [onClickTagInfo]
  );

  const shouldShowInfo = useCallback(
    (tag) =>
      !tag?.tagTypeConfig?.hideShowInfoIconInTagDisplay &&
      !isEmpty(tag?.tagTypeConfig?.attributes) &&
      Boolean(onClickTagInfo),
    [onClickTagInfo]
  );

  const sortedTags = getCombinedSortedTags(tags || [], entityType);
  const visibleTags = isCollapsed
    ? slice(sortedTags, 0, defaultLimit)
    : sortedTags;

  return {
    isCollapsed,
    shouldShowBtn: Boolean(tags?.length) && tags.length > defaultLimit,
    visibleTags,
    onClick: () => setCollapsed((currentState) => !currentState),
    onSelect: (tagValue) => () => {
      if (onEntityTagClick) {
        onEntityTagClick(tagValue);
      }
    },
    canNavigateToTag: (tag) =>
      Boolean(onEntityTagClick) && isTagNavigableInTeamform(tag),
    shouldShowInfo,
    onInfo,
  };
};
